import { useLanguage } from "../i18n/LanguageContext";
import { ArrowRight } from "lucide-react";

const HERO_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/c7cfd768-7c37-45d7-a891-1b87bfc3ae84/images/95f4e269470e750fff9889a63377fb15f4fd7c609046a4404cb27cbb4b0febac.png";

const Hero = () => {
  const { t } = useLanguage();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden bg-[#F8F8F7]"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMAGE}
          alt="Modern minimalist residential architecture"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/30 via-white/10 to-white/70" />
        <div className="absolute inset-0 bg-gradient-to-r from-white/80 via-white/20 to-transparent md:from-white/85 md:via-white/30" />
      </div>

      {/* Content */}
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 pt-36 pb-20 md:pt-48 md:pb-32 min-h-screen flex items-center">
        <div className="max-w-3xl reveal in-view w-full">
          <p
            data-testid="hero-overline"
            className="text-[12px] sm:text-sm uppercase tracking-[0.28em] font-semibold text-[#52525B] mb-6 md:mb-8"
          >
            {t.hero.overline}
          </p>
          <h1
            data-testid="hero-headline"
            className="font-serif text-[3.75rem] sm:text-6xl md:text-6xl lg:text-7xl font-light tracking-tight leading-[1.05] text-[#1A1A1A] mb-6 md:mb-8"
          >
            {t.hero.headline}
          </h1>
          <p
            data-testid="hero-subtitle"
            className="text-[1.18rem] sm:text-lg md:text-lg leading-relaxed text-[#52525B] max-w-2xl mb-10 md:mb-12"
          >
            {t.hero.subtitle}
          </p>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 sm:gap-4">
            <button
              data-testid="hero-cta-primary"
              onClick={() => scrollTo("contact")}
              className="group inline-flex items-center justify-center sm:justify-start gap-3 bg-[#1A1A1A] hover:bg-[#3F3F46] text-white px-7 py-[1.15rem] sm:px-8 sm:py-4 text-[1rem] sm:text-sm font-semibold tracking-wide uppercase transition-all duration-300 hover:-translate-y-0.5"
            >
              {t.hero.ctaPrimary}
              <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
            </button>
            <button
              data-testid="hero-cta-secondary"
              onClick={() => scrollTo("services")}
              className="inline-flex items-center justify-center sm:justify-start gap-3 border border-[#1A1A1A] text-[#1A1A1A] hover:bg-[#1A1A1A] hover:text-white px-7 py-[1.15rem] sm:px-8 sm:py-4 text-[1rem] sm:text-sm font-semibold tracking-wide uppercase transition-all duration-300"
            >
              {t.hero.ctaSecondary}
            </button>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden md:flex flex-col items-center gap-2 text-[#52525B]">
        <span className="text-[10px] uppercase tracking-[0.3em]">Scroll</span>
        <div className="w-px h-12 bg-gradient-to-b from-[#52525B] to-transparent" />
      </div>
    </section>
  );
};

export default Hero;
